import React, { createContext, useContext, useState } from 'react';
import Cookies from 'js-cookie';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(!!Cookies.get('farmerToken'));
    const [loading, setLoading] = useState(true);

    const login = (token) => {
        Cookies.set('farmerToken', token);
        setIsAuthenticated(true);
        setLoading(false);
    };

    const logout = () => {
        Cookies.remove('farmerToken');
        setIsAuthenticated(false);
        setLoading(false);
    };

    React.useEffect(() => {
        setLoading(false);
    }, []);

    React.useEffect(() => {
        setTimeout(() => setLoading(false), 2000); // simulate API
    }, []);

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
